import { type ComponentProps } from 'react';
import { Spinner } from '../spinner';
import { cn } from '../../cn';

export function LoadingScreen(props: ComponentProps<'div'>) {
  return (
    <div
      {...props}
      className={cn(
        'w-screen h-screen flex items-center justify-center',
        props.className,
      )}
    >
      <Spinner className="size-8" />
    </div>
  );
}
